const isInIframe = () => window.top && window.self !== window.top

export default isInIframe
